import gsap from 'gsap';
import CustomEase from 'gsap/CustomEase';
import { Sizes, generateAnimations, destroyAnimations } from '../utils';
gsap.registerPlugin( CustomEase );

// pending
export class PageMouseMove {
	constructor( options = {} ) {
		// General
		this.sizes = new Sizes();
		this.options = {
			...options,
			devices: options?.devices || [ 'Desktop', 'Tablet', 'Mobile' ],
			duration: options?.duration || 0.5,
		};
		this.isEnable = false;

		// Animations
		this.timelines = null;
		this.textInstances = null;
		this.enterFunc = null;
		this.leaveFunc = null;
		this.moveFunc = null;

		this.viewWidth = 0;
		this.viewHeight = 0;

		this.xTo = null;
		this.yTo = null;
	}

	init() {
		if (
			this.isEnable ||
			! this.options.devices.includes( this.sizes.device )
		)
			return;
		this.viewWidth =
			window.innerWidth || document.documentElement.clientWidth;
		this.viewHeight =
			window.innerHeight || document.documentElement.clientHeight;

		const [ theTimelines, theTextInstance ] = generateAnimations(
			null,
			this.animations
		);
		this.timelines = theTimelines;
		this.textInstances = theTextInstance;

		let timelineX, timelineY;
		if ( this.options.mouseX ) {
			if ( this.options.mouseX.animation ) {
				const animationID = this.options.mouseX.animation.theAnimation;
				timelineX = this.timelines.find(
					( item ) => item.animationID === animationID
				)?.timeline;
			}
		}
		if ( this.options.mouseY ) {
			if ( this.options.mouseY.animation ) {
				const animationID = this.options.mouseY.animation.theAnimation;
				timelineY = this.timelines.find(
					( item ) => item.animationID === animationID
				)?.timeline;
			}
		}

		let ease = 'power1.inOut';
		if ( this.options.customEase ) {
			ease = CustomEase.create( 'custom', this.options.customEase );
		} else if ( this.options.ease ) {
			ease = this.options.ease;
		}

		if ( timelineX ) {
			this.xTo = gsap.quickTo( timelineX, 'progress', {
				duration: this.options.duration,
				ease,
			} );
			gsap.set( timelineX, {
				progress: 0.5,
			} );
		}
		if ( timelineY ) {
			this.yTo = gsap.quickTo( timelineY, 'progress', {
				duration: this.options.duration,
				ease,
			} );
			gsap.set( timelineY, {
				progress: 0.5,
			} );
		}

		this.moveFunc = ( e ) => this.#move( e );
		this.enterFunc = () => this.#enter();
		this.leaveFunc = () => this.#leave();
		document.addEventListener( 'mouseenter', this.enterFunc );
		document.addEventListener( 'mouseleave', this.leaveFunc );
		this.isEnable = true;
	}

	kill() {
		if ( ! this.isEnable ) return;
		destroyAnimations(
			null,
			this.options.animations,
			this.timelines,
			this.textInstances
		);
		document.removeEventListener( 'mouseenter', this.enterFunc );
		document.removeEventListener( 'mouseleave', this.leaveFunc );
		this.timelines = null;
		this.enterFunc = null;
		this.leaveFunc = null;
		this.viewWidth = 0;
		this.viewHeight = 0;
		this.isEnable = false;
	}

	resize() {
		this.kill();
		this.init();
	}

	destroy() {
		this.kill();
		this.sizes = null;
		this.options = null;
		this.timelines = null;
		this.enterFunc = null;
		this.leaveFunc = null;
		this.viewWidth = null;
		this.viewHeight = null;
		this.isEnable = null;
	}

	#enter() {
		document.addEventListener( 'mousemove', this.moveFunc );
	}

	#leave() {
		document.removeEventListener( 'mousemove', this.moveFunc );
		this.xTo?.( 0.5 );
		this.yTo?.( 0.5 );
	}

	#move( e ) {
		if ( this.xTo ) {
			const xPercent = e.clientX / this.viewWidth;
			this.xTo( xPercent );
		}
		if ( this.yTo ) {
			const yPercent = e.clientY / this.viewHeight;
			this.yTo( yPercent );
		}
	}
}
